import { render, staticRenderFns } from "./SaleInvoiceCollectCreationModal.vue?vue&type=template&id=2c1ac099&scoped=true&"
import script from "./SaleInvoiceCollectCreationModal.vue?vue&type=script&lang=js&"
export * from "./SaleInvoiceCollectCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ac099",
  null
  
)

export default component.exports